import { render, staticRenderFns } from "./TeresaPanel.vue?vue&type=template&id=23cd9039&scoped=true&"
import script from "./TeresaPanel.vue?vue&type=script&lang=js&"
export * from "./TeresaPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cd9039",
  null
  
)

export default component.exports